module.exports = __webpack_public_path__ + "img/max-file-content-image-transfer.a8b0b60f.svg";